// extracted by mini-css-extract-plugin
export var channels = "siteFooter-module--channels--006da";
export var container = "siteFooter-module--container--4f2f3";
export var footer = "siteFooter-module--footer--b1e50";
export var logo = "siteFooter-module--logo--047d0";
export var meta = "siteFooter-module--meta--03465";